import { z } from 'zod';
/**
 * RFM-сегменты гостей: как давно и как часто гость покупает. docs/11, У8.
 *
 * Десять групп, у каждой понятное имя и понятное действие для владельца:
 * «чемпионов» благодарят, «в зоне риска» зовут обратно, «новичкам» дают повод
 * прийти второй раз. Считаются по участиям на лету, в базе не хранятся.
 *
 * Отдельным файлом, а не в отчётах: сегментом фильтруется и список гостей
 * (admin.ts), а отчёты сами зависят от admin.ts — иначе импорт пошёл бы по кругу.
 */
/** Порядок — от лучших гостей к уходящим: так сегменты и показываются. */
export const RfmSegment = z.enum([
    'CHAMPIONS',
    'LOYAL',
    'POTENTIAL',
    'NEW',
    'PROMISING',
    'NEED_ATTENTION',
    'ABOUT_TO_SLEEP',
    'AT_RISK',
    'CANT_LOSE',
    'HIBERNATING',
]);
//# sourceMappingURL=rfm.js.map